if (!customElements.get('sd-sticky-atc')) {
  customElements.define(
    'sd-sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        this.priceSource = document.getElementById(`price-${sectionId}`);
        this.button = this.querySelector('[data-sticky-button]');
        this.price = this.querySelector('[data-sticky-price]');
        if (!this.mainButton || !this.button) return;

        this.hidden = false;
        this.sync();

        this.mutationObserver = new MutationObserver(() => this.sync());
        this.mutationObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
        if (this.priceSource) {
          this.mutationObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }

        // Show only after the main button has scrolled above the viewport.
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', passed);
          this.setAttribute('aria-hidden', String(!passed));
          this.button.tabIndex = passed ? 0 : -1;
        });
        this.intersectionObserver.observe(this.mainButton);
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      sync() {
        const disabled = this.mainButton.hasAttribute('disabled') || this.mainButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = disabled;
        const label = this.mainButton.querySelector('span:not(.loading__spinner)');
        if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();

        if (!this.priceSource || !this.price) return;
        const price = this.priceSource.querySelector('.price');
        const current = price?.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price?.querySelector('.price__regular .price-item--regular');
        this.price.textContent = current ? current.textContent.trim() : '';
      }
    }
  );
}
